/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaDatePicker from 'DesignSystem/TysiaDatePicker/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  closePopover,
  viewPath = "/DesignSystem/TasksCreateForm/DueDate/Content"
  
}) {
let formDueDateValueData = fromData.useDataValue({ viewPath,
context: 'form',
path: 'due_date',
})
let aggregateData = fromAggregate.getValueOrDefault(formDueDateValueData)
let onChange = fromHelpers.useOnChange({
  children,
  closePopover,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaDatePicker
  viewPath={`${viewPath}/TysiaDatePicker`}
 data="form.due_date"
 aggregate="/Data/aggregate.js getValueOrDefault"
 value={aggregateData}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}